// Geplante Onlinestellung: für Depot-Partner nur Montage (Nutzervorgabe, 03.11.2026).
// Gegenstück zu backend/src/events/online-date.ts — dort die serverseitige Absicherung.

/**
 * True für einen Montag. `value` ist 'YYYY-MM-DD' oder ein ISO-Zeitstempel; es zählt nur
 * der Datumsteil. Rechnet auf dem reinen Datum, damit die Zeitzone des Browsers nichts
 * verschiebt. Ein leerer oder nicht lesbarer Wert ist kein Montag.
 */
export function isMonday(value: string | undefined): boolean {
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value ?? '');
  if (!match) return false;

  const [, y, m, d] = match;
  const date = new Date(Date.UTC(Number(y), Number(m) - 1, Number(d)));
  if (date.getUTCDate() !== Number(d)) return false;

  return date.getUTCDay() === 1;
}
